import { render } from "./Account.vue?vue&type=template&id=2f9d0b0f&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=2f9d0b0f&scoped=true&lang=css"
import "./Account.vue?vue&type=style&index=1&id=2f9d0b0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9d0b0f"]])

export default __exports__